module.exports = __webpack_public_path__ + "img/motorcycle-green.c7119810.svg";